import { Jackpot, createDeleteJackpotMutation } from 'shared/api';
import { ConfirmModalModel, createConfirmModalModel, declareModalData } from 'shared/lib';

export type DeleteJackpotModel = ConfirmModalModel<Jackpot, number, Jackpot>;

export const createDeleteJackpotModel = (): DeleteJackpotModel => {
	const deleteJackpotMutation = createDeleteJackpotMutation();

	const model = createConfirmModalModel({
		modalData: declareModalData<Jackpot>(),
		mapModalData: ({ id }) => id,
		mutation: deleteJackpotMutation,
		successMessageKey: 'delete-jackpot.success',
	});

	return model;
};
